import Store from '../../store';
import Http from "../../http/client";

export default async () => {
  const response = await Http.get('admin/user/groups');
  Store.commit('SetUserGroups', response.data);
}
